// ============================================================
// School Context
// ============================================================
// Multi-school context. Every feature reads schoolId from here.
// Owner can switch schools; other roles have one assigned school.

import { createContext, useCallback } from 'react';
import useSchoolStore from '@/store/schoolStore';
import useAuthStore from '@/store/authStore';
import { ROLES } from '@/constants/roles';

export const SchoolContext = createContext(null);

export function SchoolProvider({ children }) {
  const { currentSchool, schools, switchSchool: storeSwitchSchool } = useSchoolStore();
  const user = useAuthStore((state) => state.user);

  const roleUpper = String(user?.role || '').toUpperCase();
  const isOrgAdmin = roleUpper === 'ORGANIZATION_ADMIN' || user?.role === ROLES.ORGANIZATION_ADMIN;

  /**
   * Switch the active school (Organization Admin only).
   */
  const switchSchool = useCallback(
    (schoolId) => {
      if (!isOrgAdmin) {
        console.warn('Only Organization Admin can switch schools');
        return;
      }
      storeSwitchSchool(schoolId);
    },
    [isOrgAdmin, storeSwitchSchool]
  );

  /**
   * Get the current school ID — used by every service and hook.
   */
  const schoolId = currentSchool?.id || null;

  const value = {
    currentSchool,
    schools,
    schoolId,
    switchSchool,
    isOrgAdmin,
    canSwitchSchool: isOrgAdmin && schools.length > 0,
  };

  return (
    <SchoolContext.Provider value={value}>{children}</SchoolContext.Provider>
  );
}
